export const PELAJARANS_GET = 'PELAJARANS_GET';
export const PELAJARAN_JENJANGS_GET = 'PELAJARAN_JENJANGS_GET';
export const PELAJARAN_ADD = 'PELAJARAN_ADD';
export const PELAJARAN_EDIT = 'PELAJARAN_EDIT';
export const PELAJARAN_GET = 'PELAJARAN_GET';
export const PELAJARAN_SYNC = 'PELAJARAN_SYNC';
export const PELAJARAN_DELETE = 'PELAJARAN_DELETE';
